// extracted by mini-css-extract-plugin
module.exports = {"addHolding":"styles_addHolding__3CxzA","H4":"styles_H4__27-RP","input":"styles_input__1W0mI"};